import script from "./styleData.vue?vue&type=script&lang=js"
export * from "./styleData.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__